import { Token } from "@/lib/classes/BaseNetwork";
import { NetworkKey } from "@/lib/constants/cryptos";
import { type StytchHeadlessClient } from "@stytch/vanilla-js/headless";
import { createContext, Dispatch, SetStateAction } from "react";

type WidgetContextType = {
  setAddresses: Dispatch<SetStateAction<Record<string, string>>>;
  setBalances: Dispatch<{ key: NetworkKey; tokens: Token[] }>;
  setWidgetOpen: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  addresses: Record<string, string>;
  balances: Record<NetworkKey, Token[]>;
  tokensArray: Token[];
  widgetOpen: boolean;
  redirectUrl: string;
  baseUrl: string;
  stytchPublicToken: string;
  stytch?: StytchHeadlessClient;
};

export const WidgetContext = createContext<WidgetContextType>({
  addresses: {},
  balances: {},
  tokensArray: [],
  widgetOpen: false,
  isLoading: true,
  setAddresses: () => {},
  setBalances: () => {},
  setWidgetOpen: () => {},
  setIsLoading: () => {},
  redirectUrl: import.meta.env.VITE_REDIRECT_URL,
  baseUrl: "http://localhost:3000",
  stytchPublicToken: import.meta.env.VITE_STYTCH_PUBLIC_TOKEN,
});
